export const tabsNames = ["ALL", "FRIENDS", "FOLLOWING"] as const;
export type Fn = () => Promise<void>;
